import * as React from 'react'

const IsomorphicContext = React.createContext({
  server: false,
  url: null,
})

export default IsomorphicContext
